import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import ImageUpload from '../ImageUpload';

const axiosClient = axios.create({
	withCredentials: true,
});

const propTypes = {

	/**
	 * Unique id for targetting the filestack picker, if any.
	 * A default will be created if not provided.
	 */
	id: PropTypes.string,

	/**
	 * The settings for filestack.
	 */
	filestack: PropTypes.shape({

		// The API key
		apiKey: PropTypes.string,

		// The security policy and signature
		security: PropTypes.shape({

			policy: PropTypes.string,

			signature: PropTypes.string,

		}),

		// Flag indicating if mode is production.
		production: PropTypes.bool,

		// The path
		path: PropTypes.string,

		// The container
		container: PropTypes.string,

		// The region
		region: PropTypes.string,

	}).isRequired,

	/**
	 * The content to render.
	 */
	children: PropTypes.element,

	/**
	 * Callback to handle image upload - error.
	 */
	onError: PropTypes.func,

	/**
	 * Callback to handle image upload - success.
	 */
	onSuccess: PropTypes.func.isRequired,

};

/**
 * Shared component to render an image upload handler using filestack that
 * saves the image to the TC Media Library by default.
 *
 * This component is used by the ImagePicker and WYSIWYGEditor components
 * to handle file uploads.
 *
 * @param {Object} props The props.
 * @returns {Object}     The rendered component.
 */
const MediaImage = ({ id, filestack, children, onError, onSuccess }) => {

	const handleSuccess = (imageURL) => {

		axiosClient.post('/api/v2/media', {
			data: [{ url: imageURL }]
		}).then(({ data }) => {

			if (data && data.length === 1) {

				const image = `${data[0].url}?policy=${data[0].policy}&signature=${data[0].signature}`;

				onSuccess(image);

			}

		});

	};

	return (
		<ImageUpload
			id={id}
			filestack={filestack}
			onError={onError}
			onSuccess={handleSuccess}>
			{children}
		</ImageUpload>
	);
};

MediaImage.propTypes = propTypes;

export default MediaImage;
